<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="topAbout">
      <div class="titleLine">活动简介</div>
      <div class="bodyRect">
        &nbsp;&nbsp;&nbsp;&nbsp;《寻找美人鱼》是PADI美人鱼课程专项推广活动，计划参与者可向活动方申请最高不超过5000元/人的专项活动补贴，用作PADI美人鱼/进阶美人鱼课程学习。<br>
        &nbsp;&nbsp;&nbsp;&nbsp;活动参与者需年满18周岁，芝麻信用高于600分，并在活动期内，邀请三位用户参与本活动并完成PADI美人鱼/进阶美人鱼课程。
      </div>
      <!-- <div v-if="agentIcon" class="agentIcon"><img :src="agentIcon"></div> -->
    </div>
    <div class="inputRect">
      <div class="titleLine">立即报名</div>
      <div class="line">
        <van-field
          v-model="data.loaclName"
          clearable
          label="姓名"
          placeholder="请输入姓名"
          required
          :disabled="isDisabled"
          @blur="onLocalNameChange"
        />
        <van-field
          v-model="data.lastName"
          clearable
          label="英文姓"
          placeholder="请输入英文姓"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.firstName"
          clearable
          label="英文名"
          placeholder="请输入英文名"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.phone"
          clearable
          label="手机号码"
          placeholder="请输入手机号码"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.idCardNumber"
          clearable
          label="身份证号码"
          placeholder="请输入身份证号码"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.passportNumber"
          clearable
          label="护照号码"
          placeholder="请输入护照号码(2选1)"
          :disabled="isDisabled"
        />
        <FieldSelect v-model="data.courseName" :list="diveCourseList" label="课程" placeholder="请选择课程" @change="onCourseChange" />
        <FieldSelect v-model="data.cityName" :list="cityList" label="所在城市" placeholder="请选择所在城市" @change="onCityChange" />
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>芝麻信用截图</span><br><span :style="'color:'+GetColorMain()" @click="onViewDemo">查看示例</span></div>
          <van-uploader
            v-model="fileList"
            class="imageUpload"
            multiple
            :disabled="isDisabled"
            :deletable="!isDisabled"
            :max-count="1"
            :after-read="afterRead"
          />
        </div>
        <template v-if="data && data.activityMermaidUserId">
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label"><span>提交时间</span></div>
            {{ formatDate(data.createTime,'yyyy/MM/dd hh:mm',true) }}
          </div>
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label"><span>状态</span></div>
            <span v-if="data.isPass===null">待审核</span>
            <span v-if="data.isPass===true" style="color:#3f3">已审核通过</span>
            <span v-if="data.isPass===false" style="color:#f33">审核不通过</span>
          </div>
          <div v-if="data.isPass===false && data.about" class="van-cell van-field">
            <div class="van-cell__title van-field__label"><span>不通过原因</span></div>
            {{ data.about }}
          </div>
          <div v-if="data.isPass===true && data.about" class="van-cell van-field">
            <div class="van-cell__title van-field__label"><span>备注</span></div>
            {{ data.about }}
          </div>
          <div v-if="data.isSandbox" class="van-cell van-field">
            <div class="van-cell__title van-field__label"><span>测试模式</span></div>
            当前是测试模式订单!
          </div>
        </template>
      </div>
    </div>
    <div v-if="data.isPass===true" class="inputRect">
      <div class="titleLine">电子协议</div>
      <div v-if="priceSign>0" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>签约手续费</span></div>
        CNY {{ ShowMoney(priceSign) }}
      </div>
      <template v-if="signData">
        <div v-if="signData.priceSign>0" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>支付状态</span></div>
          <van-tag v-if="signData.isPayFinish" type="success">已支付</van-tag>
          <van-tag v-if="!signData.isPayFinish" type="danger">待支付</van-tag>
        </div>

        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>签约状态</span></div>
          {{ GetEnumText('Em_EsignState',signData.state) }}
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>申请时间</span></div>
          {{ formatDate(signData.createDate,'yyyy/MM/dd hh:mm',true) }}
        </div>
        <div v-if="signData.finishDate" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>完成时间</span></div>
          {{ formatDate(signData.finishDate,'yyyy/MM/dd hh:mm',true) }}
        </div>
        <div v-if="signData.isEsignError" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>异常</span></div>
          <van-tag type="danger">签约异常,如需帮助请联系客服!</van-tag>
        </div>
      </template>
    </div>
    <!-- <div class="emptyRect" /> -->
    <div class="buttonRect"><van-button v-if="!isDisabled && !data.activityMermaidUserId" square :loading="buttonLoading" size="large" :color="GetColorMain()" @click="onUpdate">参加活动</van-button></div>
    <div class="buttonRect"><van-button v-if="!isDisabled && data.activityMermaidUserId" square :loading="buttonLoading" size="large" :color="GetColorMain()" @click="onUpdate">修改信息</van-button></div>

    <div class="buttonRect"><van-button v-if="data && data.isPass===true && !data.eSignId" square :loading="buttonLoading" size="large" :color="GetColorMain()" @click="onSign">签署协议</van-button></div>
    <div class="buttonRect"><van-button v-if="data && data.isPass===true && signData && !signData.isPayFinish" square :loading="buttonLoading" size="large" :color="GetColorMain()" @click="onPaySign">签署协议</van-button></div>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Swipe, SwipeItem, Dialog, Uploader, ImagePreview, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { getUserBase, compressorImageList, MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Dialog.name]: Dialog,
    [Uploader.name]: Uploader,
    [ImagePreview.name]: ImagePreview,
    [Tag.name]: Tag,
    TopBar,
    FieldSelect,
    wxShare
  },
  data() {
    return {
      titleTop: '',
      title: '《寻找美人鱼计划》报名',
      backurl: '/my/index',
      system: undefined,
      uid: undefined,
      diveCourseList: [],
      cityList: [],
      data: {
        lastName: undefined,
        firstName: undefined,
        localName: undefined
      },
      signData: undefined,
      isDisabled: true,
      buttonLoading: false,
      fileList: [],
      timeoutAutoFinish: undefined,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      agentIcon: undefined,
      priceSign: undefined
    }
  },

  created() {
    this.system = getUrlKey('system')
    this.uid = getUrlKey('uid')

    this.titleTop = GetSysTitle()
    setTimeout(() => {
      this.diveCourseList = [
        { text: '美人鱼课程', value: '美人鱼课程' },
        { text: '进阶美人鱼课程', value: '进阶美人鱼课程' }
      ]
      this.cityList = [
        { text: '北京', value: '北京' },
        { text: '上海', value: '上海' },
        { text: '广州', value: '广州' },
        { text: '成都', value: '成都' },
        { text: '西安', value: '西安' },
        { text: '昆明', value: '昆明' },
        { text: '南宁', value: '南宁' },
        { text: '重庆', value: '重庆' }
      ]
      this.data.courseName = this.diveCourseList[0].value
    }, 1)

    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initCourse(callback) {
      request({
        url: '/DiveMermaid/getMermailDiveCourse',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        var diveCourseList = []
        response.data.forEach(el => {
          diveCourseList.push({ text: el.v, value: el.k })
        })
        this.diveCourseList = JSON.parse(JSON.stringify(diveCourseList))

        if (callback) {
          callback()
        }
      })
    },
    beforeRouteLeave(to, from, next) {
      if (this.timeoutAutoFinish) {
        clearTimeout(this.timeoutAutoFinish)
        this.timeoutAutoFinish = undefined
      }
      next()
    },
    setFinishRead() {
      request({
        url: '/Activity/setReadUserActivityMermaid',
        method: 'post'
      }).then(response => {

      })
    },
    init() {
      request({
        url: '/Activity/getUserActivityMermaid',
        method: 'post',
        params: { uid: this.uid }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.agentIcon = response.data.agentIcon
        this.priceSign = response.data.priceSign
        this.initShare()
        this.isDisabled = true
        if (response.data && response.data.mermaidUser) {
          if (response.data.mermaidUser.isPass === false) {
            this.isDisabled = false
          }
          if (!response.data.mermaidUser.isRead) {
            this.timeoutAutoFinish = setTimeout(() => {
              this.setFinishRead()
            }, 5000)
          }
          this.signData = response.data.sign
          this.data = response.data.mermaidUser
          if (this.data.zhimaUrl) {
            this.fileList = [{ url: this.data.zhimaUrl }]
          }
        } else {
          this.isDisabled = false
        }
      })
    },
    onViewDemo() {
      ImagePreview(['/img/findmermaidzhimaDemo.jpg'])
    },
    initShare() {
      getUserBase(userInfo => {
        this.shareTitle = '《寻找美人鱼》计划报名通道'
        this.shareAbout = '《寻找美人鱼》是PADI美人鱼系列推广活动，为参与者提供不超过5000元/人高额课程补贴。'
        this.shareTimeline = '《寻找美人鱼》是PADI美人鱼系列推广活动，为参与者提供不超过5000元/人高额课程补贴。'
        this.shareUrl = undefined
        this.shareUrl = GetSelfUrl() + 'mermaid/mermaidUser?system=' + this.system + '&uid=' + userInfo.userId
        this.shareIcon = GetSelfUrl() + 'img/findmermaidlogo.jpg'
      })
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onCourseChange(select) {
      this.data.courseName = select.value
    },
    onCityChange(select) {
      this.data.cityName = select.value
    },
    onLocalNameChange() {
      if (this.data.loaclName) {
        this.onGetNamePy(this.data.loaclName, (ln, fn) => {
          this.data.firstName = fn
          this.data.lastName = ln
        })
      }
    },
    onGetNamePy(name, callback) {
      request({
        url: '/User/getNamePySpace',
        method: 'post',
        params: { name: name }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data.lastName, response.data.firstName)
        }
      })
    },
    checkIdCardInfo(idCard, callback) {
      if (!idCard) {
        callback(true)
        return
      }
      idCard = idCard.trim()
      if (idCard.length !== 18) {
        if (callback) {
          callback(false)
        }
        return
      }
      request({
        url: '/User/getUserIdCardInfo',
        method: 'post',
        params: { id: idCard }
      }).then(Response => {
        if (!Response.success) {
          if (callback) {
            callback(false)
          }
          return
        }
        if (!Response.data.isSuccess) {
          if (callback) {
            callback(false)
          }
          return
        }
        if (callback) {
          callback(true)
        }
      })
    },
    onUpdate() {
      if (!this.data.phone || this.data.phone.length < 11) {
        MyNotify('info', '请输入11位手机号码')
        return false
      }
      if (!this.data.passportNumber && !this.data.idCardNumber) {
        MyNotify('info', '至少输入身份证号码或护照号码其中一个')
        return false
      }
      if (!this.data.loaclName || this.data.loaclName.length < 1) {
        MyNotify('info', '请输入至少2位中文姓名')
        return false
      }
      if (!this.data.lastName || this.data.lastName.length < 1) {
        MyNotify('info', '请输入英文(拼音)姓')
        return false
      }
      if (!this.data.firstName || this.data.firstName.length < 1) {
        MyNotify('info', '请输入英文(拼音)名')
        return false
      }
      if (!this.data.courseName) {
        MyNotify('info', '请选择课程')
        return false
      }
      if (!this.data.cityName) {
        MyNotify('info', '请选择开课城市')
        return false
      }
      if (!this.fileList || this.fileList.length <= 0) {
        MyNotify('info', '请上传芝麻信用截图')
        return false
      }
      this.buttonLoading = true
      this.checkIdCardInfo(this.data.idCardNumber, (isSuccess) => {
        if (!isSuccess) {
          this.buttonLoading = false
          MyNotify('info', '请输入正确的18位身份证号码')
          return
        }

        Dialog.confirm({
          title: '请核对信息',
          message: '请核对信息是否准确无误:\r\n' +
         '姓名:' + this.data.loaclName + '\r\n' +
         '英文姓:' + this.data.lastName + '\r\n' +
         '英文名:' + this.data.firstName + '\r\n' +
         '电话号码:' + this.data.phone + '\r\n' +
         '身份证号码:' + (this.data.idCardNumber ? this.data.idCardNumber : '-') + '\r\n' +
         '护照号码:' + (this.data.passportNumber ? this.data.passportNumber : '-') + '\r\n' +
         '所在城市:' + this.data.cityName + '\r\n' +
         '课程:' + this.data.courseName
        }).then(() => {
          this.onUpdateDo()
        })
          .catch(() => {
            this.buttonLoading = false
          })
      })
    },
    onUpdateDo() {
      this.buttonLoading = true

      this.uploadImg(this.fileList, (urls) => {
        this.data.agentId = this.uid
        this.data.zhimaUrl = urls
        request({
          url: '/Activity/updateUserActivityMermaid',
          method: 'post',
          data: this.data
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '报名成功', 2000)
          this.init()
        })
      })
    },
    uploadImg(files, callback) {
      var noFile = true
      var fileList = []
      files.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback('')
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=findmermaiduserzhima',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    afterRead() {

    },
    onSign() {
      this.buttonLoading = true
      request({
        url: '/Activity/signUserActivityMermaid',
        method: 'post'
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          this.$router.push('/store/pay/0?id=' + response.data)
        } else {
          MyNotify('success', '申请签约成功，请稍后通过短信链接完成签约', 8000)
          this.init()
        }
      })
    },
    onPaySign() {
      this.$router.push('/store/pay/0?id=' + this.signData.payOrderId)
    }
  }
}
</script>
<style scoped>
.topAbout{
    background-color: #fff;
    padding: 1em;
    margin-bottom: 1em;
    position: relative;
}
.topAbout .agentIcon{
  position: absolute;
  right: 1em;
  top: 0.5em;
  width:2em;
  height: 2em;
  overflow: hidden;
  border-radius: 0.4em;
}
.topAbout .agentIcon img{
  width: 100%;
}
.topAbout .bodyRect{
    font-size: 0.7em;
    line-height: 1.8em;
}
.titleLine{
    font-weight: 700;
    font-size: 0.9em;
    padding-bottom: 0.5em;
}
.inputRect{
    padding: 1em;
    background-color: #fff;
    margin-bottom: 1em;
}
.emptyRect{
  height: 3em;
}
.buttonRect{
  /* background-color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0; */
}
</style>
